export default __webpack_public_path__ + "static/media/Sestini.818a7055.png";